import access from "./access.json";
import admin from "./admin.json";
import blastPattern from "./blastPattern.json";
import common from "./common.json";
import consumables from "./consumables.json";
import dashboard from "./dashboard.json";
import dewatering from "./dewatering.json";
import drillBlast from "./drillBlast.json";
import drillBlastSetup from "./drillBlastSetup.json";
import drilling from "./drilling.json";
import explosives from "./explosives.json";
import geology from "./geology.json";
import nav from "./nav.json";
import production from "./production.json";
import reportBuilder from "./reportBuilder.json";
import reports from "./reports.json";
import royalties from "./royalties.json";
import server from "./server.json";
import stoppages from "./stoppages.json";
import targets from "./targets.json";
import telemetry from "./telemetry.json";
import vocabulary from "./vocabulary.json";

export const en = { access, admin, blastPattern, common, consumables, dashboard, dewatering, drillBlast, drillBlastSetup, drilling, explosives, geology, nav, production, reportBuilder, reports, royalties, server, stoppages, targets, telemetry, vocabulary };

export const NAMESPACES = Object.keys(en) as (keyof typeof en)[];
